const Footer = () => {
    return (
        <>
            <footer class="page-footer">
                <p class="mb-0">Copyright © 2021. All right reserved.</p>
            </footer>
        </>
    );
}
export default Footer;